import {
  EServiceType,
  ICheckPublishTermSchema,
} from '../../../../../repositories/monolith-python/entities/CheckPublishTermSchema';
import { IServicePeriod } from '../../../../reducers';

interface IMapAuctionTermParams {
  bet: number;
  period: IServicePeriod;
  days: number;
}

export function mapAuctionTerm(params: IMapAuctionTermParams): ICheckPublishTermSchema {
  const { bet, period, days } = params;
  const { tariffIdentificator, token } = period;
  const type = days > 1 ? 'periodical' : 'dailyTermless';

  return {
    type,
    days,
    services: [EServiceType.auction],
    tariffIdentificator,
    dynamicPrice: bet,
    token,
  };
}
